<template>
   <PageFull header="Адм. блэклист получателей" type="white" :fullwidth="true" :nopadding="true">
        <template v-slot:body>
            <div class="flex flex-column w-full">
                <RecipientsBlacklistList />
            </div>
        </template>
    </PageFull>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import RecipientsBlacklistList from '@/components/admin/RecipientsBlacklistList.vue'
import PageFull from '@/components/sides/PageFull.vue'

export default {
    data() {
        return {

        }
    },
    components: {
        RecipientsBlacklistList,
        PageFull
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    }
}
</script>